<template>
  <div class="d-flex align-items-center" style="min-height: 100vh; background-color: #fdfdfd;">
    <div class="col-sm-8 col-md-6 col-lg-4 mx-auto" style="min-width: 300px;">
      <!-- Logos -->
      <div class="row mt-5 mb-5" v-if="schoolLogo">
        <div class="d-flex justify-content-center col-6 align-items-center border-right border-secondary py-2">
          <img :src="schoolLogo" style="max-width: 150px; max-height: 100px;" alt="School Logo" />
        </div>
        <div class="d-flex justify-content-center col-6 align-items-center">
          <img :src="logo" style="max-width: 150px; max-height: 100px;" alt="Transition" />
        </div>
      </div>
      <div class="text-center mt-5 mb-5" v-else>
        <img :src="logo" width="200" alt="Transition" />
      </div>

      <b-card class="shadow" style="border: none;">
        <h5 class="text-center mb-1 font-weight-bold">Login</h5>
        <p class="text-center text-muted mb-4">Sign in to your account</p>

        <b-alert variant="success" :show="!!$route.query.passwordReset" dismissible class="text-center">
          <i class="material-icons mr-1" style="font-size: 18px; vertical-align: middle;">check_circle</i>
          Password reset successfully. Please login with your new password.
        </b-alert>

        <b-form @submit.prevent="handleLogin">
          <b-form-group label="Email" label-class="form-label">
            <b-form-input
              v-model="email"
              type="email"
              placeholder="Enter email"
              required
            />
          </b-form-group>

          <b-form-group label="Password" label-class="form-label">
            <div style="position: relative; display: flex; align-items: center;">
              <b-form-input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter password"
                required
                style="padding-right: 40px;"
              />
              <button
                type="button"
                class="btn btn-link"
                style="position: absolute; right: 0; z-index: 9; color: #858796;"
                @click="showPassword = !showPassword"
              >
                <i class="material-icons" style="font-size: 20px;">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
              </button>
            </div>
          </b-form-group>

          <div v-if="error" class="alert alert-danger mt-3" role="alert">
            Invalid email or password.
          </div>

          <div class="form-group">
            <b-button type="submit" variant="primary" block :disabled="isLoading" style="height: 2.3rem;">
              <span v-if="isLoading">
                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Signing in...
              </span>
              <span v-else>Sign In</span>
            </b-button>
          </div>

          <div class="text-center">
            <router-link :to="{ name: 'forgot-password' }" class="text-muted" style="text-decoration: underline;">Forgot Password?</router-link>
          </div>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import logo from '@/assets/images/logos/transition_crm_logo.png';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: false,
      isLoading: false,
      showPassword: false,
      logo,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    schoolLogo() {
      // If school branding is available from domain or previous session, show it
      return null;
    },
  },
  methods: {
    ...mapActions('auth', ['login']),
    async handleLogin() {
      this.error = false;
      this.isLoading = true;
      try {
        await this.login({ email: this.email, password: this.password });
        const redirect = this.$route.query.redirect || '/contacts';
        this.$router.push(redirect);
      } catch (err) {
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
